export default function initalizeSentry() {
    try {
        const scriptTag = document.createElement("script")
        const sentryConfig = JSON.parse(process.env.SENTRY)

        scriptTag.onload = () => {
            if (typeof window !== "undefined" && window.Sentry) {
                window.Sentry.init({
                    dsn: sentryConfig.DSN,
                    sampleRate: 1,
                    ignoreErrors: sentryConfig.IGNORE_ERROR_LIST,
                    allowUrls: sentryConfig.ALLOW_URLS,
                })
            }
        }

        scriptTag.id = "sentryScript"
        scriptTag.src = "https://browser.sentry-cdn.com/6.19.4/bundle.tracing.min.js"
        scriptTag.crossOrigin = "anonymous"

        document.head.appendChild(scriptTag)
    } catch (err) {
        console.log("Error initializing sentry", err)
    }
}

export const captureMessage = (errorMessage) => {
    if (typeof window !== "undefined" && window.Sentry) {
        window.Sentry.captureMessage(errorMessage)
    } else {
        console.error(`Unable to capture message: ${errorMessage}`)
    }
}

export const captureException = (exception) => {
    if (typeof window !== "undefined" && window.Sentry) {
        window.Sentry.captureException(exception)
    } else {
        console.error(`Unable to capture exception: ${exception}`)
    }
}
